/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Typography, IconButton, Menu, MenuItem, Tooltip, Collapse, Paper, Dialog, AppBar, Toolbar, Divider, Popover, Button } from '@material-ui/core';

import Add from '@material-ui/icons/Add'
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import CheckCircleOutlined from '@material-ui/icons/CheckCircleOutlined'
import DeleteOutlined from '@material-ui/icons/DeleteOutline'
import Fullscreen from '@material-ui/icons/Fullscreen';
import FullscreenExitOutlined from '@material-ui/icons/FullscreenExitOutlined';
import Clear from '@material-ui/icons/Clear';
import Edit from '@material-ui/icons/Edit';

import Slide from '@material-ui/core/Slide';

import { v4 as uuidv4 } from 'uuid';

import AddButton from './AddButton'
import RemoveButton from './RemoveButton'
import BooleanOp from './BooleanOp'
import Condition from './Condition'
import Action from './Action'


const clone = require('rfdc')()


const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        // primary: {
        //     main: "#FF6600",  
        //     contrastText: "#FFFFFFFF"
        // },
        secondary: {
          main: '#ff9100',
        },
      },
})

const bool_ops = ["and", "or", ""]


const styles = theme => ({

})

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class DataMarker extends Component {
    state = {
        data_marker : {},
        menu_anchor_el : null,
        menu_open : false,
        root : false,
        open : true,
        full_screen : false,
        delete_anchorEl : null,
        delete_open : false
    }

    componentWillMount = () => {
        this.setState({...this.state, data_marker : this.props.data_marker}, () => console.log('Data marker Opening State: ', this.state))
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.data_marker.edit !== this.state.data_marker.edit) {
            let new_state = clone(this.state)
            new_state.data_marker.edit = this.props.data_marker.edit
            this.setState({...new_state})
        }
    }

    handleToggle = () => {

        this.setState({...this.state, open : !this.state.open})
    }

    renderExpandIcon = () => {
        if (this.state.open === true) {
            return (
                <div style = {{marginRight: '10px'}}>
                    <IconButton size = 'small' onClick = {this.handleToggle}>
                        <ExpandLess/>
                    </IconButton>
                </div>
            )
        } else {
            return (
                <div style = {{marginRight: '10px'}}>
                    <IconButton size = 'small' onClick = {this.handleToggle}>
                        <ExpandMore/>
                    </IconButton>
                </div>
            )
        }
    }

    renderEditActionIcon = () => {
        if (this.state.data_marker.edit === true) {
            return (
                <Tooltip title = 'Confirm'>
                    <IconButton disabled = {!this.enableConfirm()} style = {{color: this.enableConfirm() === true ? '#4caf50' : null, marginRight : '10px'}} size = 'small' onClick = {() => this.props.pushDataMarker(this.state.data_marker.id, this.state.data_marker)}>
                        <CheckCircleOutlined/>
                    </IconButton>
                </Tooltip>
            )
        } else {
            return (
                <Tooltip title = 'Edit'>
                    <IconButton style = {{marginRight : '10px'}} size = 'small' onClick = {() => this.props.editDataMarker(this.props.type, this.state.data_marker.id)}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            )
        }
    }

    renderFullScreenIcon = () => {
        if (this.state.full_screen === false) {
            return (
                <Tooltip title = 'Full Screen Editor'>
                    <IconButton color = 'primary' style = {{marginRight : '10px'}} size = 'small' onClick = {this.toggleFullScreen}>
                        <Fullscreen/>
                    </IconButton>
                </Tooltip>
            )
        } else {
            return (
                <Tooltip title = 'Exit Full Screen'>
                    <IconButton color = 'primary' style = {{marginRight : '10px'}} size = 'small' onClick = {this.toggleFullScreen}>
                        <FullscreenExitOutlined/>
                    </IconButton>
                </Tooltip>
            )
        }
    }

    enableConfirm = () => {
        if ((Object.keys(this.state.data_marker.trigger).length > 0 && this.state.data_marker.actions.length > 0)) {
            return true
        } else {
            return false
        }
    }

    confirmDelete = () => {
        return (
            <Popover
                id = {"filter_list"}
                open = {this.state.delete_open}
                anchorEl={this.state.delete_anchorEl}
                onClose={() => this.setState({...this.state, delete_anchorEl : null, delete_open : false})}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps = {{
                    square : true,
                    elevation : 8,
                    style : {
                        margin : 0,
                        padidng : 0
                    }
                }}
            >
                <div style = {{width : '300px', padding : '10px'}}>
                    <Typography variant = "capion" display = "block">Do you want to continue deleting the data marker?</Typography>
                    <div style ={{ width : '100%', display : 'flex', flexDirection : 'row'}}>
                        <Button 
                            color = "primary"
                            onClick = {() => this.setState({...this.state, delete_anchorEl : null, delete_open : false})}
                        >Cancel</Button>
                        <Button 
                            color = "secondary"
                            onClick = {() => this.setState({...this.state, delete_anchorEl : null, delete_open : false}, 
                                () => this.props.removeDataMarker(this.props.type, this.state.data_marker.id))}
                        >Delete</Button>
                    </div>
                </div>
            </Popover>
        )
    }

    renderDataMarker = () => {
        return (
            <Fragment>
                <Paper
                    // elevation = {this.state.data_marker.edit === true ? 3 : 0}
                    variant = {'outlined'}
                    style = {{
                        backgroundColor : this.state.data_marker.edit === true ? '#fafafa': '#EEEEEE', 
                        margin : '10px', 
                        padding : '5px',

                    }}>
                    <ThemeProvider theme = {blue_theme}>
                        <div style = {{display : 'flex', flexDirection : 'row'}}>
                            <div style = {{flexGrow : 1, cursor : 'pointer'}} onClick = {this.handleToggle}>
                                <Typography 
                                    variant = 'subtitle2'
                                    color = {this.state.data_marker.edit === true ? 'textPrimary' : 'textSecondary'}
                                >{this.props.type.toUpperCase()} / Data Marker #{this.props.index + 1}</Typography>
                            </div>
                            {this.renderEditActionIcon()}
                            {this.renderFullScreenIcon()}
                            <Tooltip title = 'Delete'>
                                <IconButton 
                                    style = {{color : '#f44336', marginRight : '10px'}} 
                                    size = 'small' 
                                    onClick = {(event) => {
                                        this.setState({
                                            ...this.state, 
                                            full_screen : false,
                                            delete_anchorEl : event.currentTarget,
                                            delete_open : true
                                        })
                                    }}
                                >
                                    <DeleteOutlined/>
                                </IconButton>
                            </Tooltip>
                            {this.confirmDelete()}
                            {this.renderExpandIcon()}
                        </div>
                        <Collapse in = {this.state.open}>
                            <Paper 
                                elevation = {3}
                                variant = {this.state.data_marker.edit === true ? 'elevated' : 'outlined'}
                                style = {{
                                    backgroundColor : this.state.data_marker.edit === true ? '#FFFFFF': '#F5F5F5',
                                    padding: '5px', 
                                    margin : '5px'
                                }}
                            >
                                <Typography style = {{display : 'block'}} variant = 'overline'>Trigger</Typography>
                                {this.renderTriggers()}
                                {this.renderRootButton()}
                            </Paper>
                            <Paper 
                                elevation = {3}
                                variant = {this.state.data_marker.edit === true ? 'elevated' : 'outlined'}
                                style = {{
                                    backgroundColor : this.state.data_marker.edit === true ? '#FFFFFF': '#F5F5F5',
                                    padding: '5px', 
                                    margin: '5px'
                                }}
                            >
                                <Typography style = {{display : 'block'}} variant = 'overline'>Actions</Typography>
                                {this.renderActions()}
                                <AddButton role = 'action' tag = 'Action' addAction = {this.addAction}/>
                            </Paper>
                        </Collapse>
                    </ThemeProvider>
                </Paper>
                <Divider style = {{marginTop : '5px', marginBotton : '5px'}} />
            </Fragment>
        )
    }

    addAction = () => {
        let new_state = clone(this.state)
        let new_id = uuidv4()
        let new_action = {
            id : new_id,
            name: "",
            params : []
        }

        new_state.data_marker.actions.push(new_action)

        this.setState({...new_state})
    }

    removeAction = (id) => {
        let new_state = clone(this.state)
        let index = new_state.data_marker.actions.findIndex(action => action.id === id)
        new_state.data_marker.actions.splice(index, 1)

        this.setState({...new_state})
    }

    renderActions = () => {
        let actions = this.state.data_marker.actions.map((action, i) => {
            return (
                <Action 
                    index = {i}
                    config = {action}
                    ic_name = {this.props.ic_name} 
                    iu_name = {this.props.iu_name}
                    updateAction = {(id, key_name, value) => this.updateAction(id, key_name, value)}
                    removeAction = {(id) => this.removeAction(id)}
                    disabled = {!this.state.data_marker.edit}
                    ws_name = {this.props.ws_name}
                    field_config = {this.props.field_config}
                    action_config = {this.props.action_config}
                    action_params_config = {this.props.action_params_config}
                />
            )
        })

        return actions
    }

    renderRootButton = () => {
        if (this.state.root === false) {
            return (
                <AddButton 
                    role = 'trigger' 
                    cur_id = '0-0' 
                    step = {0} 
                    index = {0} 
                    tag = 'Trigger' 
                    disabled = {!this.state.data_marker.edit}
                    addBoolOp = {(cur_id, step, index, type) => this.addRootOperation(cur_id, step, index, type)}
                />
            )
        } else {
            return (
                <RemoveButton 
                    role = 'trigger' 
                    cur_id = '0-0' 
                    step = {0} 
                    index = {0} 
                    tag = 'Trigger'
                    disabled = {!this.state.data_marker.edit}
                    removeBoolOp = {(cur_id, step, index, type) => this.removeRootOperation(cur_id, step, index, type)}
                />
            )
        }
    }

    updateOperation = (obj, key_path, value) => {
        console.log('Key Path: ', key_path)
        let updated_obj = this.updateObject(obj, key_path, value)
        let new_state = clone (this.state)

        new_state.data_marker.trigger = this.iterateAndUpdate(updated_obj, new_state.data_marker.trigger)

        this.setState({...new_state}, () => console.log('Updated DM State: ', this.state))
    }

    updateObject = (obj, key_path, value) => {
        let cur_obj = obj
        key_path.map(key => {
            if(key === key_path[key_path.length -1]) {
                cur_obj[key] = value
            } else {
                cur_obj = cur_obj[key]
            }
        })

        return cur_obj
    }

    updateAction = (id, key_name, value) => {

        let new_state = clone(this.state)
        let index = new_state.data_marker.actions.findIndex(action => action.id === id)
        new_state.data_marker.actions[index][key_name] = value

        this.setState({...new_state} , () => console.log('Updated DM State: ', this.state))
    }

    iterateAndUpdate = (obj, state_obj) => {
        if (state_obj.id === obj.id) {
            state_obj = obj
        } else {
            for (let i = 0; i < state_obj.operands.length; i++) {
                this.iterateAndUpdate(obj, state_obj.operands[i])
            }
        }

        return state_obj
    }

    iterateAndPushTrigger = (cur_id, obj, step, index, boolop_obj) => {

        console.log('Object ID: ', obj.id)
        console.log('Current ID: ', cur_id)
        if (obj.id === cur_id) {
            console.log('Bool Op Object : ', boolop_obj)
            boolop_obj.id = cur_id + '/' + (step + 1) + '-' +(obj.operands.length)
            obj.operands.push(boolop_obj)
        } else {
            for (let i = 0; i < obj.operands.length; i++) {
                this.iterateAndPushTrigger(cur_id, obj.operands[i], step, index, boolop_obj)
            }
        }

        return obj
    }

    iterateAndRemoveTrigger = (cur_id, obj, step, index) => {
        if (obj.id === cur_id) {
            obj.operands.pop()
        } else {
            for (let i = 0; i < obj.operands.length; i++) {
                this.iterateAndRemoveTrigger(cur_id, obj.operands[i], step, index)
            }
        }

        return obj
    }

    addRootOperation = (cur_id, step, index, type) => {
        let new_state = clone (this.state)
        let new_op

        if (type === 'boolean') {
            new_op = {
                id : "0-0",
                boolop: "and",
                operands : [],
                condition : {}
            }
        } else {
            new_op = {
                id : "0-0",
                boolop : 'leaf',
                condition : {
                    field : "",
                    operator : {
                        name : "",
                        params : []
                    }
                },
                operands : []
            }
        }

        new_state.data_marker.trigger = new_op
        new_state.root = true
        this.setState({...new_state})
    }

    removeRootOperation = (cur_id, step, index, type) => {
        let new_state = clone(this.state)
        new_state.data_marker.trigger = {}
        new_state.root = false
        this.setState({...new_state})
    }

    addOperation = (cur_id, step, index, type) => {
        console.log('Adding Bool Op for Step ' + step + ' and index ' + index)
        let new_state = clone (this.state)
        let new_op

        if (type === 'boolean') {
            new_op = {
                boolop: "and",
                operands : [],
                condition : {}
            }
        } else {
            new_op = {
                boolop : 'leaf',
                condition : {
                    field : "",
                    operator : {
                        name : "",
                        params : []
                    }
                },
                operands : []
            }
        }

        console.log("New Object :", new_op)

        new_state.data_marker.trigger = this.iterateAndPushTrigger(cur_id, new_state.data_marker.trigger, step, index, new_op)

        this.setState({...new_state}, () => console.log('Added Boolop: ', this.state))
    }

    removeOperation = (cur_id, step, index,) => {
        let new_state = clone (this.state)
        new_state.data_marker.trigger = this.iterateAndRemoveTrigger(cur_id, new_state.data_marker.trigger, step, index)
        this.setState({...new_state}, () => console.log('Added Boolop: ', this.state))
    }

    renderTriggers = () => {
        if (Object.keys(this.state.data_marker.trigger).length > 0) {
            if (this.state.data_marker.trigger.boolop !== 'leaf') {
                return (
                    <BooleanOp 
                        id = '0-0' 
                        key = {'root'} 
                        step = {0} 
                        index = {0}
                        edit = {this.state.data_marker.edit}
                        config = {this.state.data_marker.trigger} 
                        addOp = {(cur_id, step, index, type) => this.addOperation(cur_id, step, index, type)}
                        removeOp = {(cur_id, step, index) => this.removeOperation(cur_id, step, index)}
                        updateObj = {(obj, key_path, value) => this.updateOperation(obj, key_path, value)}
                        field_config = {this.props.field_config}
                        operator_config = {this.props.operator_config}
                        operator_params_config = {this.props.operator_params_config}
                        ic_name = {this.props.ic_name} 
                        iu_name = {this.props.iu_name}
                        ws_name = {this.props.ws_name}
                    />
                )
            } else {
                return (
                    <Condition 
                        id = '0-0' 
                        step = {0} 
                        index = {0} 
                        config = {this.state.data_marker.trigger} 
                        ic_name = {this.props.ic_name} 
                        iu_name = {this.props.iu_name}
                        ws_name = {this.props.ws_name}
                        field_config = {this.props.field_config}
                        operator_config = {this.props.operator_config}
                        operator_params_config = {this.props.operator_params_config}
                        updateObj = {(obj, key_path, value) => this.updateOperation(obj, key_path, value)}
                        disabled = {!this.state.data_marker.edit}
                    />
                )   
            }
        }
    }

    handleMenuOpen = (event) => {
        let new_state = clone(this.state)
        new_state.menu_anchor_el = event.currentTarget
        new_state.menu_open = true
        this.setState({...new_state}, () => console.log('Data Marker State :', this.state))
    }

    handleMenuClose = () => {
        this.setState({...this.state, menu_anchor_el : null, menu_open : false}, () => console.log('Menu Close State :', this.state))
    }

    toggleFullScreen = () => {
        this.setState({...this.state, full_screen: !this.state.full_screen})
    }

    renderFullScreen = () => {
        return (
            <Dialog fullScreen open = {this.state.full_screen} TransitionComponent={Transition}>
                <ThemeProvider theme = {blue_theme}>
                    <AppBar position = 'fixed'>
                        <Toolbar variant = 'dense'>
                            <Typography style = {{flexGrow : 1}} variant = 'button'>Data Marker Editor</Typography>
                            <Tooltip title = 'Close Editor'>
                                <IconButton style = {{color : '#ffffff', marginRight : '10px'}} size = 'small' onClick = {this.toggleFullScreen}>
                                    <Clear/>
                                </IconButton>
                            </Tooltip>
                        </Toolbar>
                    </AppBar>
                </ThemeProvider>
                <div style = {{marginTop : '50px'}}>
                    {this.renderDataMarker()}
                </div>  
            </Dialog>
        )
    }

    render() {
        const { classes } = this.props
        return (
            <Fragment>
                {this.renderDataMarker()}
                {this.renderFullScreen()}
            </Fragment>
        );
    }
}

export default withStyles(styles)(DataMarker);